<template>
    <div v-if="messages.length">
        <div class="alert"
             v-for="message in messages"
             :class="'alert-' + message.level">
            <button type="button"
                    v-on:click.prevent="drop(message)"
                    class="close"
                    data-dismiss="alert"
                    aria-label="Fermer">
                <span aria-hidden="true">&times;</span>
            </button>

            <strong>{{ message.title }}</strong> {{ message.message }}
        </div>
    </div>
</template>

<script type="text/ecmascript-6">
    import {manager} from '../messages';

    export default {
        data() {
            return {
                manager: manager,
                unRegisterCallback: undefined,
                messages: []
            };
        },
        ready() {
            this.unRegisterCallback = this.manager.onChange((messages) => {
                this.messages = messages;
            });
        },
        beforeDestroy() {
            if (this.unRegisterCallback) {
                this.unRegisterCallback();
            }
        },
        methods: {
            drop(message) {
                this.manager.drop(message.idx);
            }
        }
    };
</script>



// WEBPACK FOOTER //
// Alerts.vue?37ea9991